// Composite skeleton for the Lifecycle page. Delegates to the widget's own
// skeleton so the placeholder shape mirrors the live chart area.

import { LifecycleTrendSkeleton } from "@widgets/lifecycle-trend";

export interface LifecycleSkeletonProps {
  loadingLabel?: string;
}

export function LifecycleSkeleton({ loadingLabel }: LifecycleSkeletonProps) {
  return (
    <div
      aria-busy="true"
      aria-label={loadingLabel}
      className="flex flex-col gap-6"
    >
      <LifecycleTrendSkeleton />
    </div>
  );
}
